<template>
	<client-only>
		<div class="iframe-page" v-html="htmlContent"></div>
	</client-only>
</template>
<script lang="ts" setup>
import { ref, nextTick, onMounted, getCurrentInstance, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { store } from '@/store/index';
import pinia from '@/store/store';
import { storeToRefs } from 'pinia';
import { ApiCustomprodContent } from '@/api/content';
definePageMeta({
	requiresAuth: false,
	isShowLogin: true,
});
const route = useRoute();
const router = useRouter();
let piniaStore = store(pinia);
const {
	appContext: {
		config: { globalProperties },
	},
} = getCurrentInstance();
const htmlContent = ref();
onMounted(() => {
	getCustomProdContent();
});
let { getLang } = storeToRefs(piniaStore);
const langValue = computed(() => {
	return getLang.value.toLowerCase();
});

function getCustomProdContent() {
	ApiCustomprodContent({
		cid: piniaStore.getChannelCid,
		lang: langValue.value,
		id: route.params.id,
	}).then((res) => {
		htmlContent.value = res.html;
	});
}
</script>
<style lang="less">
.iframe-page {
	min-height: 100%;
	width: 100%;
}
</style>
